<h1>Demo</h1>

<app-material>
    <ng-container header>
        <h2>Texts</h2>
    </ng-container>
    <ng-container body>
        <section id="basics">
            <h1>H1</h1>
            <h2>H2</h2>
            <h3>H3</h3>
            <h4>H4</h4>
            <h5>H5</h5>
            <p>Pararaph</p>
        </section>
    </ng-container>
</app-material>

<app-material>
    <ng-container header>
        <h2>Buttons</h2>
    </ng-container>
    <ng-container body>
        <section id="buttons">
            <app-button type="primary">Primary</app-button>
            <app-button type="secondary">Secondary</app-button>
            <app-button type="warning">Warning</app-button>
            <app-button type="danger">Danger</app-button>
            <app-button type="simple">Simple</app-button>
            <a>Link</a>
            <app-icon library="material" variant="keyboard_arrow_down"></app-icon>
        </section>

        <section id="fab">
            <h3>Fab</h3>
            <app-fab [items]="fabItems"></app-fab>
        </section>

    </ng-container>
</app-material>

<app-material>
    <ng-container header>
        <h2>Inputs</h2>
    </ng-container>
    <ng-container body>
        <section id="inputs">
            <form [formGroup]="form">
                <h3>Text Input</h3>
                <app-input formControlName="text"
                           [formControl]="control('text')"
                           placeholder="Top Aligned Label"
                           label="Label"
                           labelAlign="top">
                </app-input>
                <app-component-state name="Text"
                                     [validity]="control('text').valid"
                                     [value]="control('text').value">
                </app-component-state>

                <h3>Number Input</h3>
                <!-- The separators and sign also take space in the maxlength computation -->
                <app-input formControlName="text"
                           [formControl]="control('number')"
                           [allowNegative]="true"
                           [maxLength]="11"
                           placeholder="Numero"
                           mask="separator.2"
                           label="Number"
                           labelAlign="top"
                           type="number">
                </app-input>
                <app-component-state name="Number"
                                     [validity]="control('number').valid"
                                     [value]="control('number').value">
                </app-component-state>

                <h3>Datepicker Input</h3>
                <app-input-datepicker
                    [formControl]="control('date')"
                    label="Datepicker"
                    labelAlign="top"
                    [placeholder]="'admin.audits.form.placeholders.startDate' | translate"
                    [showErrors]="control('date').invalid && control('date').touched">
                </app-input-datepicker>
                <app-component-state name="Date"
                                     [validity]="control('date').valid"
                                     [value]="control('date').value">
                </app-component-state>

                <h3>Daterange Input</h3>
                <app-input-datepicker
                    [formControl]="control('range')"
                    selectionMode="range">
                </app-input-datepicker>
                <app-component-state name="Date"
                                     [validity]="control('range').valid"
                                     [value]="control('range').value">
                </app-component-state>

                <h3>Dropdown Input</h3>
                <app-dropdown
                    [items]="items"
                    displayField="name"
                    valueField="value"
                    emptyText="Please select one"
                    [formControl]="control('dropdown')"
                    label="Dropdown"
                    labelAlign="top"
                    [m2]="false"
                    [showErrors]="control('dropdown').invalid && control('dropdown').touched">
                </app-dropdown>

                <app-component-state name="Dropdown"
                                     [validity]="control('dropdown').valid"
                                     [value]="control('dropdown').value">
                </app-component-state>

                <h3>Dropdown Multiselect</h3>
                <app-dropdown-multiple
                    [items]="items"
                    displayField="name"
                    valueField="value"
                    emptyText="Please select multiple"
                    [formControl]="control('multiDropdown')"
                    label="Dropdown"
                    labelAlign="top"
                    [m2]="false"
                    [showErrors]="control('multiDropdown').invalid && control('multiDropdown').touched">
                </app-dropdown-multiple>
                <app-component-state name="MultiDropdown"
                                     [validity]="control('multiDropdown').valid"
                                     [value]="control('multiDropdown').value">
                </app-component-state>

                <h3>Autocomplete Input</h3>
                <app-dropdown-autocomplete labelAlign="top"
                                           [formControl]="control('autocomplete')"
                                           [items]="items"
                                           label="Dropdown autocomplete"
                                           emptyText="Select items">
                </app-dropdown-autocomplete>
                <app-component-state name="Autocomplete"
                                     [validity]="control('autocomplete').valid"
                                     [value]="control('autocomplete').value">
                </app-component-state>

                <h3>Switch input</h3>
                <app-input-switch [formControl]="control('switch')"
                                  topLabel="Switch"
                                  onLabel="On"
                                  offLabel="Off">
                </app-input-switch>
                <app-component-state name="Switch"
                                     [validity]="control('switch').valid"
                                     [value]="control('switch').value">
                </app-component-state>

                <h3>Checkbox Input</h3>
                <app-input-checkbox
                    label="Checkbox"
                    [formControl]="control('checkbox')">
                    Label
                </app-input-checkbox>
                <h3>Multi-line Input</h3>
                <app-multiple-input
                    [formControl]="control('multi')"
                    [showErrors]="showValidations"
                    label="Multi"
                    placeholder="{{
                    'admin.lines.create-modal.details.location-input.placeholder'
                        | translate
                }}">
                </app-multiple-input>
                <app-component-state name="Multi"
                                     [validity]="control('multi').valid"
                                     [value]="control('multi').value">
                </app-component-state>
                <h3>Textarea input</h3>
                <app-textarea [formControl]="control('textarea')"
                              [maxLength]="30"
                              label="Textarea">
                </app-textarea>
                <app-component-state name="Textarea"
                                     [validity]="control('textarea').valid"
                                     [value]="control('textarea').value">
                </app-component-state>
            </form>
        </section>
        <section id="states">
            <form [formGroup]="form">
                <h3>States</h3>
                <app-input formControlName="text"
                           [formControl]="control('text')"
                           placeholder="Left Aligned Label"
                           label="Label"
                           labelAlign="left">
                </app-input>

                <app-input formControlName="text"
                           [formControl]="control('text')"
                           placeholder="Top Aligned Label"
                           label="Label"
                           labelAlign="top">
                </app-input>

                <app-input formControlName="text"
                           [formControl]="control('text')"
                           placeholder="Doesn't matter"
                           label="Floating label"
                           labelAlign="floating">
                </app-input>

                <app-input formControlName="text"
                           [formControl]="control('text')"
                           placeholder="Doesn't matter"
                           label="Floating label on Legacy M2 Styling"
                           labelAlign="floating"
                           [m2]="true">
                </app-input>
            </form>
        </section>
    </ng-container>
</app-material>

<app-material>
    <ng-container header>
        <h2>Alerts</h2>
    </ng-container>
    <ng-container body>
        <section id="alerts">
            <app-alert type="info"
                       message="This is an info"
                       [responsive]="true">
            </app-alert>
            <app-alert type="warning"
                       message="This is a warning"
                       [responsive]="true">
            </app-alert>
            <app-alert type="error"
                       message="This is a danger"
                       [responsive]="true">
            </app-alert>
            <app-alert type="custom"
                       [responsive]="true">
                <ng-template #error>
                    This is a custom alert with a chosen background and a link
                    <a class="open-tool-request-link"> Link</a>
                </ng-template>
            </app-alert>
        </section>
    </ng-container>
</app-material>

<app-material>
    <ng-container header>
        <h2>Labels</h2>
    </ng-container>
    <ng-container body>
        <section id="labels">
            <app-display-label label="Some label"
                               value="Some Value">
            </app-display-label>
        </section>
    </ng-container>
</app-material>

<app-material>
    <ng-container header>
        <h2>Toastrs</h2>
    </ng-container>
    <ng-container body>
        <section id="toasts">
            <app-button type="primary" (click)="onToast('info')">Info</app-button>
            <app-button type="success" (click)="onToast('success')">Success</app-button>
            <app-button type="danger" (click)="onToast('danger')">Danger</app-button>
            <app-button type="warning" (click)="onToast('warning')">Warning</app-button>
        </section>
    </ng-container>
</app-material>

<app-material>
    <ng-container header>
        <h2>Components</h2>
    </ng-container>
    <ng-container body>
        <section id="components">
            <h3>Picklist</h3>
            <app-picklist
                [formControl]="control('picklist')"
                [showValidations]="showValidations"
                [source]="items"
                [target]="targetItems"
                icon="star"
                sourceHeader="Sources"
                targetHeader="Targets">
            </app-picklist>
            <app-component-state name="Picklist"
                                 [validity]="control('picklist').valid"
                                 [value]="control('picklist').value">
            </app-component-state>
            <h3>Tooltip</h3>
            <app-tooltip
                type="info"
                record="This is an info tooltip"
                tooltipPosition="top">
            </app-tooltip>
            <app-tooltip
                type="warning"
                record="This is a warning tooltip"
                tooltipPosition="bottom">
            </app-tooltip>
            <app-tooltip
                type="important"
                record="This is an important tooltip"
                tooltipPosition="left">
            </app-tooltip>

            <h3>Tabs</h3>
            <app-tabs [tabs]="tabs"
                      [autorouting]="false"
                      [material]="false"
                      (tabClicked)="onTabClick($event)">
            </app-tabs>
            <h3>Icon Button</h3>
            <app-icon-button [responsive]="true">

            </app-icon-button>
            <h3>Tree</h3>
            <app-tree [isMaterial]="false"
                      emptyMessage="{{'admin.lifts.batches.noToolsSelected' | translate}}"
                      [(items)]="treeDisplayTools"
            ></app-tree>

            <h3>Listbox</h3>
            <app-listbox [items]="listboxItems"
                         style="height: 300px"
                         [selectable]="true"
                         [isMaterial]="false"
                         [formControl]="control('listbox')"
                         [emptyMessage]="'admin.partNumbers.form.placeholders.noRelatedPNs' | translate">
            </app-listbox>
            <app-component-state name="Listbox"
                                 [validity]="control('listbox').valid"
                                 [value]="control('listbox').value">
            </app-component-state>
            <h3>Carousel</h3>
            <app-photo-carousel [photos]="photos"
                                [numVisibleItems]="4"
                                [canDelete]="true"
                                (deletePhoto)="selectCarouselFiles($event)">
            </app-photo-carousel>
            <h3>Accordion</h3>
            <app-accordion>
                <app-accordion-item>
                    <ng-template #head>First Tab Header
                        <app-icon library="fontawesome" variant="fa-cog" [simple]="true"></app-icon>
                    </ng-template>
                    <ng-template #content>
                        First Tab Content
                    </ng-template>
                </app-accordion-item>
                <app-accordion-item>
                    <ng-template #head>Second Tab Header</ng-template>
                    <ng-template #content>Second Tab Content</ng-template>
                </app-accordion-item>
                <app-accordion-item [open]="true">
                    <ng-template #head>Third Tab Header</ng-template>
                    <ng-template #content>Third Tab Content</ng-template>
                </app-accordion-item>
            </app-accordion>
            <h3>Language Picker</h3>
            <app-language-picker></app-language-picker>
        </section>
    </ng-container>
</app-material>

<app-material>
    <ng-container header>
        <h2>Cards</h2>
    </ng-container>
    <ng-container body>
        <section id="cards">
            <h3>File Card</h3>
            <app-file-card icon="fa-file" title="File Name">

            </app-file-card>
            <h3>Scroll list Item</h3>
            <app-scroll-list-item
                [leftIcon]="scrollListItem?.icon"
                [rightIcon]="scrollListItem?.icon"
                [hasDelete]="true"
                [selected]="scrollListItem?.selected"
                [description]="scrollListItem?.description"
                [title]="scrollListItem?.title"
                [subtitle]="scrollListItem?.subtitle"
                [item]="scrollListItem"
                [highlighted]="scrollListItem?.highlighted"
                (click)="onSelect($event)">
            </app-scroll-list-item>

            <h3>Maintenance task</h3>
            <app-task [task]="task"
                      [canDuplicate]="true"
                      [canDelete]="true"
                      [canSelect]="true"
                      [displayCogs]="true"
                      [info]="'La pașa vine un arab ...'"
                      [hasObservations]="true"
                      [canHighlight]="false">
            </app-task>
        </section>
    </ng-container>
</app-material>


<!--<div class="page">-->
<!--    <div class="page-header text-center">-->
<!--        <h3>Demo components</h3>-->
<!--    </div>-->
<!--    <div class="page-content">-->
<!--        <div class="card">-->
<!--            <form [formGroup]="form">-->
<!--                <h5>Form elements</h5>-->
<!--                <div class="row">-->
<!--                    <div class="col s6">-->
<!--                        <app-input formControlName="text"-->
<!--                                   [formControl]="form.controls.text"-->
<!--                                   [showErrors]="showValidations"-->
<!--                                   placeholder="Insert text"-->
<!--                                   label="Textfield">-->
<!--                        </app-input>-->
<!--                        <app-input-number formControlName="number"-->
<!--                                          [formControl]="form.controls.number"-->
<!--                                          [showErrors]="showValidations"-->
<!--                                          placeholder="Insert number"-->
<!--                                          label="Numberfield">-->
<!--                        </app-input-number>-->
<!--                        <app-input-datepicker formControlName="datepicker"-->
<!--                                              [formControl]="form.controls.datepicker"-->
<!--                                              [showErrors]="showValidations"-->
<!--                                              placeholder="Insert date"-->
<!--                                              label="Datepicker">-->
<!--                        </app-input-datepicker>-->
<!--                        <app-dropdown formControlName="dropdown"-->
<!--                                      [formControl]="form.controls.dropdown"-->
<!--                                      [showErrors]="showValidations"-->
<!--                                      [items]="items"-->
<!--                                      displayField="name"-->
<!--                                      valueField="id"-->
<!--                                      label="Dropdown"-->
<!--                                      emptyText="Select items">-->
<!--                        </app-dropdown>-->
<!--                        <app-input-duration formControlName="duration"-->
<!--                                            [formControl]="form.controls.duration"-->
<!--                                            [showErrors]="showValidations"-->
<!--                                            placeholder="Insert text"-->
<!--                                            label="Time duration picker">-->
<!--                        </app-input-duration>-->
<!--                        <div class="row">-->
<!--                            <div class="col s12">-->
<!--                                <app-input-switch formControlName="switch"-->
<!--                                                  onLabel="On"-->
<!--                                                  offLabel="Off"-->
<!--                                                  topLabel="Toggle switch"></app-input-switch>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col s6 left-labels">-->
<!--                        <app-input formControlName="text"-->
<!--                                   labelAlign="left"-->
<!--                                   [formControl]="form.controls.text"-->
<!--                                   [showErrors]="showValidations"-->
<!--                                   placeholder="Insert text"-->
<!--                                   label="Textfield">-->
<!--                        </app-input>-->
<!--                        <app-input-number formControlName="number"-->
<!--                                          labelAlign="left"-->
<!--                                          [formControl]="form.controls.number"-->
<!--                                          [showErrors]="showValidations"-->
<!--                                          placeholder="Insert number"-->
<!--                                          label="Numberfield">-->
<!--                        </app-input-number>-->
<!--                        <app-input-datepicker formControlName="datepicker"-->
<!--                                              labelAlign="left"-->
<!--                                              [formControl]="form.controls.datepicker"-->
<!--                                              [showErrors]="showValidations"-->
<!--                                              placeholder="Insert date"-->
<!--                                              label="Datepicker">-->
<!--                        </app-input-datepicker>-->
<!--                        <app-dropdown formControlName="dropdown"-->
<!--                                      labelAlign="left"-->
<!--                                      [formControl]="form.controls.dropdown"-->
<!--                                      [showErrors]="showValidations"-->
<!--                                      [items]="items"-->
<!--                                      displayField="name"-->
<!--                                      valueField="id"-->
<!--                                      label="Dropdown"-->
<!--                                      emptyText="Click to view items">-->
<!--                        </app-dropdown>-->
<!--                        <app-input-duration formControlName="duration"-->
<!--                                            labelAlign="left"-->
<!--                                            [formControl]="form.controls.duration"-->
<!--                                            [showErrors]="showValidations"-->
<!--                                            placeholder="Insert text"-->
<!--                                            label="Time duration picker">-->
<!--                        </app-input-duration>-->
<!--                        <app-dropdown-autocomplete labelAlign="left"-->
<!--                                                   [formControl]="form.controls.autocomplete"-->
<!--                                                   [showErrors]="showValidations"-->
<!--                                                   [items]="items"-->
<!--                                                   label="Dropdown autocomplete"-->
<!--                                                   emptyText="Select items">-->
<!--                        </app-dropdown-autocomplete>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </form>-->
<!--            <h5>Modals</h5>-->
<!--            <button class="btn btn-primary"-->
<!--                    (click)="openEngraveTool()">Engrave tool-->
<!--            </button>-->

<!--            <h5>Components</h5>-->

<!--            <h6>Task:</h6>-->
<!--            <div *ngFor="let task of tasks">-->
<!--                <app-task [task]="task"-->
<!--                          [canDelete]="task.id===1"-->
<!--                          [info]="'admin.toolMaintenancePlans.task.partOfPlans' | translate:{ number: task.name.length }"-->
<!--                ></app-task>-->
<!--                <br>-->
<!--            </div>-->

<!--            <h6>Empty Logical Grouper:</h6>-->
<!--            <app-logical-grouper [baseData]="grouperDropdownItems[0].baseData"-->
<!--                                 [linkData]="grouperDropdownItems[0].linkData"-->
<!--                                 [isSelectable]="grouperDropdownItems[0].selectionData.isSelectable"-->
<!--                                 [isSelected]="grouperDropdownItems[0].selectionData.isSelected">-->
<!--            </app-logical-grouper>-->

<!--            <h6>Logical Grouper:</h6>-->
<!--            <app-logical-grouper [items]="tasks"-->
<!--                                 [baseData]="grouperDropdownItems[1].baseData"-->
<!--                                 [linkData]="grouperDropdownItems[1].linkData"-->
<!--                                 [isSelectable]="grouperDropdownItems[1].selectionData.isSelectable"-->
<!--                                 [isSelected]="grouperDropdownItems[1].selectionData.isSelected">-->
<!--            </app-logical-grouper>-->

<!--            <h6>Grouper List:</h6>-->
<!--            <app-grouper-list [dropdownItems]="grouperDropdownItems">-->
<!--            </app-grouper-list>-->

<!--            <h6>Assignation dropdown</h6>-->
<!--            <div class="row">-->
<!--                <app-assignation-dropdown [items]="dropdownItems.slice(0, 5)"></app-assignation-dropdown>-->
<!--                <app-assignation-dropdown [items]="dropdownItems.slice(5)"></app-assignation-dropdown>-->
<!--            </div>-->

<!--            <h6>Accordion</h6>-->
<!--            <app-maintenance-accordion [items]="accordionItems.slice(0, 2)"></app-maintenance-accordion>-->
<!--            <h6>Recurrence Definition Accordion</h6>-->
<!--            <app-maintenance-accordion [items]="accordionItems.slice(2)"></app-maintenance-accordion>-->

<!--            <h6>Timer: </h6>-->
<!--            <p>Initialized at start state:</p>-->
<!--            <app-timer [state]="'start'" [elapsedTime]="1000" [standardTime]="5000"></app-timer>-->
<!--            <p>Initialized at pause state:</p>-->
<!--            <app-timer [state]="'pause'" [elapsedTime]="1000" [standardTime]="5000"></app-timer>-->
<!--            <p>Default:</p>-->
<!--            <app-timer [standardTime]="5000"></app-timer>-->
<!--            <app-photo-carousel [photos]="photos"-->
<!--                                [numVisibleItems]="5"-->
<!--                                [headerText]="'Photos'"-->
<!--                                (deletePhoto)="onDeletePhoto($event)">-->
<!--            </app-photo-carousel>-->
<!--            <p>Ticket status component</p>-->
<!--            <app-ticket-status [ticket]="ticket" *ngIf="ticket"></app-ticket-status>-->
<!--            <h5>Strain components</h5>-->
<!--            <app-excel-paste-table></app-excel-paste-table>-->
<!--            <app-excel-chart-paste></app-excel-chart-paste>-->

<!--            <button class="btn btn-primary"-->
<!--                    (click)="openGageConfigurationModal()">-->
<!--              Gage Configuration-->
<!--            </button>-->
<!--            <h5>Messages</h5>-->
<!--            <app-message [severity]="'info'" [message]="'This is an info message'"></app-message>-->
<!--            <app-message [severity]="'success'" [message]="'This is a success message'"></app-message>-->
<!--            <app-message [severity]="'warn'" [message]="'This is a warn message'"></app-message>-->
<!--            <app-message [severity]="'error'" [message]="'This is an error message'"></app-message>-->
<!--        </div>-->
<!--    </div>-->

<!--    <app-tool-engrave-modal></app-tool-engrave-modal>-->
<!--    <app-strain-gage-configuration-modal (save)="onGageSave($event)">-->
<!--    </app-strain-gage-configuration-modal>-->
